<script setup lang="ts">
import { faExternalLinkAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon, TmlBubble } from '@teemill/components';

defineProps<{
  domain: string;
}>();
</script>

<template>
  <a :href="`https://${domain}`" target="_blank" class="cursor-pointer">
    <TmlBubble class="w-10 h-10 flex justify-center items-center overflow-hidden">
      <FontAwesomeIcon :icon="faExternalLinkAlt" />
    </TmlBubble>
  </a>
</template>
